// extracted by mini-css-extract-plugin
export default {"add_unit":"AddUnit_add_unit__dq1MI","title":"AddUnit_title__tUWRw","submit_button_container":"AddUnit_submit_button_container__ht-WD","submit_button":"AddUnit_submit_button__K1kht"};